const isProd = process.env.NODE_ENV === 'production';
const istest = process.env.NODE_ENV === 'test';
if (isProd) {
  MapUrl = projectConfig.MapUrl || 'https://gisapi.xyabcd.com';
} else if (istest) {
  MapUrl = 'http://test.gisapi.com';
} else {
  MapUrl = projectConfig.MapUrl || 'http://test.gisapi.com';
}
